module.exports = __webpack_public_path__ + "img/LogoSuedam.fde79e21.png";